import { NOTIFICATION_PRIORITIES, NOTIFICATION_TYPES } from '@/constants/stringVars';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  title: yup
    .string()
    .trim()
    .required('Title is required.')
    .min(2, 'Title needs to be at least 2 characters long.')
    .max(50, 'Title length cannot exceed 50 characters.'),
  message: yup
    .string()
    .trim()
    .required('Message is required.')
    .min(2, 'Message needs to be at least 2 characters long.')
    .max(180, 'Message length cannot exceed 180 characters.'),
  channels: yup
    .array()
    .of(yup.string().required('At least one channel is required.'))
    .min(1, 'At least one channel is required.')
    .max(4, 'You can select a maximum of 4 channels.'),
  notificationPriority: yup
    .string()
    .required('Notification priority is required.')
    .oneOf(NOTIFICATION_PRIORITIES, 'Notification priority must be one of the following.'),
  type: yup
    .string()
    .required('Notification type is required.')
    .oneOf(NOTIFICATION_TYPES, 'Notification type must be one of the following.'),
});

export type TNotificationForm = {
  title: string;
  message: string;
  channels: string[];
  notificationPriority: string;
  type: string;
};

export { validationSchema as notificationValidationSchema };
